(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('SupplierPanelV2Controller', SupplierPanelV2Controller);

    SupplierPanelV2Controller.$inject = ['CompanyCustom', '$location', '$scope', 'Principal', 'LoginService', '$state', 'CompanyInfoQuery', 'ServantCustom', '__config', '$localStorage', '$translate', '$translatePartialLoader', 'ActivityTypeInfoCustom', 'CompanySubscriptionStatusCustom'];

    function SupplierPanelV2Controller(CompanyCustom, $location, $scope, Principal, LoginService, $state, CompanyInfoQuery, ServantCustom, __config, $localStorage, $translate, $translatePartialLoader, ActivityTypeInfoCustom, CompanySubscriptionStatusCustom) {
        var vm = this;
        vm.collapseMenu = collapseMenu;
        vm.menuIcon = menuIcon;
        vm.account = null;
        vm.menuState = menuState;
        vm.menuWiden = false;
        vm.isAuthenticated = null;
        vm.login = LoginService.open;
        vm.guidTipsEnable = false;
        vm.goToCurrentServant = goToCurrentServant;
        vm.goto = goto;
        vm.canViewReport = true;
        vm.uncheck = uncheck;
        vm.init = init;
        var cckey = $location.search().cckey;
        // loadCompanyInfo();
        vm.isWorkSpace = false;
        ;
        vm.checkActivityType = checkActivityType;
        vm.__config = __config;
        vm.wedoMeetMode = false;
        vm.logoSource = "content/images/planovin.png";
        vm.setServantTooltip = setServantTooltip;
        vm.servantTitle = "";
        vm.servantListTitle = "";
        vm.isLiActive = isLiActive;
        vm.hasSubscription = true;
        vm.goToState = goToState;


        vm.init();

        function init() {

            $translatePartialLoader.addPart('activityType');
            $translatePartialLoader = $translate.refresh();

            if (!cckey)
                loadCompanyInfo();

            vm.servantClass = "fa fa-address-card fa-fw";
            vm.servantTranslateFile = "supplierPanel.sideMenu.servantInfo-v2";
            Principal.getCurrentCompanyFeatureList();

            // if(vm.__config.appMode =='event')
            // {
            //     vm.wedoMeetMode = true;
            //     vm.logoSource = "content/images/wedomeet.png"
            // }
            if (vm.__config.appName && vm.__config.appName == 'planovin') {
                // vm.logoSource = "content/images/planovin-white-space.svg"
                vm.logoSource = "content/images/planovin.png"
            }

        }

        function menuIcon(x) {
            x.classList.toggle("change");
        }

        function changeCurrentCompany() {
            if (cckey) {
                vm.company = null;
                CompanyCustom.changeCurrentCompany(cckey).query(function (c) {

                    loadCompanyInfo();

                });
            }

        }

        function collapseMenu() {

        }

        function loadCompanyInfo() {
            CompanyInfoQuery.getCurrentCompanyInfo().get(function (company) {
                if (company != null && company != undefined) {
                    vm.company = company;

                    ActivityTypeInfoCustom.getActivityTypeInfoByType(vm.company.activityType).query(function (result) {
                        vm.companyActivityTypeInfo = result;
                        checkActivityType();
                    })
                }

            })

            hasActiveSubscription();


        }

        vm.guidTipsConfig = [
            {
                type: "title",
                heading: "Welcome to the NG-Joyride demo",
                text: '<div class="row"><div id="title-text" class="col-md-12"><span class="main-text">Welcome to <strong>Ng Joyride Demo</strong></span><br><span>( This demo will walk you through the features of Ng-Joyride. )</span><br/><br/><span class="small"><em>This can have custom html too !!!</em></span></div></div>'

            }, {
                type: "element",
                selector: "#scheduleStartDate",
                heading: "Custom Title",
                text: "The demo finishes.Head over to github to learn more",
                placement: "bottom",
                scroll: false
            }

        ];


        function goToCurrentServant() {
            ServantCustom.findServantByCurrentUser().query().$promise.then(function (result) {

                if (vm.hasSubscription)
                    $state.transitionTo('supplierPanel-v2.companyServants.edit', {id: result.id});
                else
                    $state.go('supplierPanel-v2.companySubscriptionStatusV2');

            });

        }

        function goto(state) {
            $state.transitionTo('supplierPanel' + state);
        }

        function menuState() {
            vm.menuWiden = false;
        }

        function uncheck() {

            // if (vm.checked == event.target.value)
            vm.checked = false
        }

        function checkActivityType() {

            if (vm.company && vm.companyActivityTypeInfo) {
                setServantTooltip();
                if (vm.companyActivityTypeInfo.servantType && vm.companyActivityTypeInfo.servantType == 'RESOURCE') {
                    vm.isWorkSpace = true;
                    vm.servantTranslateFile = "supplierPanel.sideMenu.workSpaceInfo-v2";
                    vm.servantClass = "fa fa-building fa-fw";
                    return;
                }


            }

            vm.isWorkSpace = false;

        }


        function setServantTooltip() {

            vm.servantTranslateFileOptions = "";
            vm.servantListTitle = "";

            if (vm.company && vm.companyActivityTypeInfo && vm.companyActivityTypeInfo.servantListTitle)
                // vm.servantTranslateFileOptions = 'tikonApp.ActivityType.ActivityTypeServants.'+vm.company.activityType ;
                vm.servantListTitle = vm.companyActivityTypeInfo.servantListTitle;
        }


        function toggleSideMenu() {
            var wrapper = document.getElementById("page-wrapper");
            var side = document.getElementById("sidebarV2");
            if (wrapper && side) {
                if (side.classList.contains('open')) {
                    wrapper.classList.remove('compact');
                    side.classList.remove('open');
                } else {
                    wrapper.classList.add('compact');
                    side.classList.add('open');
                }

            }
        }

        function isLiActive(id) {
            var li = document.getElementById(id);
            if (li.classList.contains('active'))
                return true;
            else
                return false;

        }

        function hasActiveSubscription() {
            CompanySubscriptionStatusCustom.isCurrentCompanyHasActiveSubscription().query(hasSubscriptionSuccess, hasSubscriptionError);

            function hasSubscriptionSuccess(result) {
                if (result.status == 'DONE')
                    vm.hasSubscription = true;
                else
                    vm.hasSubscription = false;
            }

            function hasSubscriptionError() {
                vm.hasSubscription = false;
            }

        }


        function goToState(state, param) {
            if (param)
                $state.go(state, param);
            else
                $state.go(state);
        }

        $scope.$on('toggleSideMenu', function () {
            toggleSideMenu();
        });


        $scope.$on('resetToggleSideMenu', function () {
            var wrapper = document.getElementById("page-wrapper");
            var side = document.getElementById("sidebarV2");
            if (wrapper && side) {
                if (side.classList.contains('open')) {
                    wrapper.classList.remove('compact');
                    side.classList.remove('open');
                }
            }
        });


        $scope.$watch(function () {
            return cckey;
        }, function () {
            changeCurrentCompany();
        });
    }
})();
